// src/config/menu.ts
import { levels } from "@/lib/script-levels";

export const getScaryNavTitle = (
  currentGameLevel: number | null | undefined,
): string => {
  if (currentGameLevel === null || currentGameLevel === undefined)
    return "Scary!";
  if (currentGameLevel === levels.length - 1) return "Master!"; // Level 10 is the finish line
  if (currentGameLevel === 0) return "Scary!";
  return `Level ${currentGameLevel + 1}`;
};

export interface NavItem {
  title: string;
  to?: string;
  href?: string;
  disabled?: boolean;
  external?: boolean;
  label?: string;
  hidden?: boolean;
}

export interface NavItemWithChildren extends NavItem {
  items?: NavItemWithChildren[];
  devOnly?: boolean;
}

// Data-dependent navigation items (used in main navbar)
export const dataNav: NavItemWithChildren[] = [
  {
    title: "Analyze Account",
    items: [
      {
        title: "Trends & PMax Channels",
        href: "/trends",
      },
      {
        title: "Keywords, Search Terms & nGrams",
        href: "/keywords",
      },
      {
        title: "Products & ngrams",
        href: "/products",
      },
      {
        title: "Tree View",
        href: "/treemap",
      },
      {
        title: "PMax Placements",
        href: "/placements",
      },
      {
        title: "Placement Network Analysis",
        href: "/placement-network",
      },
      {
        title: "Asset Performance",
        href: "/asset",
      },
      {
        title: "Hourly Trends",
        href: "/hourly",
      },
      {
        title: "Budget Optimisation",
        href: "/analysis",
      },
      {
        title: "Budget Pacing",
        href: "/budget",
      },
      {
        title: "Profit Curve",
        href: "/curve",
      },
      {
        title: "ProfitMax",
        href: "/profitmax",
      },
      {
        title: "Quick Wins",
        href: "/wins",
      },
    ],
  },
  {
    title: "Insights",
    href: "/insights",
  },
  {
    title: "Scripts",
    href: "/scripts",
  },
  {
    title: "Buy",
    href: "/buy",
  },
  {
    title: "Membership",
    href: "/ai",
  },
];

// Tutorial navigation items
export const tutorialNav: NavItem[] = [
  {
    title: "Scary",
    href: "/scary",
  },
  {
    title: "NLE",
    href: "/nle",
  },
  {
    title: "PSA",
    href: "/psa",
  },
  {
    title: "Script Help",
    href: "/script-help",
  },
];

// Utility/hidden navigation items
export const utilityNav: NavItem[] = [
  {
    title: "Home",
    href: "/",
    hidden: true,
  },
  {
    title: "Setup",
    href: "/setup",
    hidden: true,
  },
  {
    title: "Settings",
    href: "/settings",
    hidden: true,
  },
  {
    title: "Story",
    href: "/story",
    hidden: true,
  },
];

export const getUpdatedNav = (
  currentGameLevel: number | null | undefined,
): NavItem[] => {
  return [
    ...utilityNav,
    ...dataNav,
    {
      title: getScaryNavTitle(currentGameLevel),
      href: "/scary",
    },
  ];
};
